import React from "react";

const CusTitle = ({
	homeTitle,
	className,
	tag = "h2",
}: {
	homeTitle: string;
	className?: string;
	tag?: "h1" | "h2";
}) => {
	const Tag = tag;
	return (
		<Tag className={`py-10 text-4xl font-bold max-md:py-7 max-md:text-2xl ${className}`}>{homeTitle}</Tag>
	);
};

export default CusTitle;
